import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'elc-service';
import { ResponsiveModal } from 'elc-responsive-modal';
import { Button } from 'elc-buttons';
import styled from 'styled-components';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';
import { CartLimitReachedModalController } from '../../controllers/CartLimitReachedModalController';

export interface ICartLimitReachedModal {
    translations?: ICartLimitReachedModalTranslations;
}

export interface ICartLimitReachedModalTranslations {
    cartLimitReached: string;
    okLabel: string;
}

const ModalMessageContainer = styled.div`
    max-width: 480px;
`;

const ModalFooter = styled.div`
    text-align: center;
`;

@translate(['cartLimitReached', 'okLabel'])
@observer
export class CartLimitReachedModal extends React.Component<ICartLimitReachedModal> {
    private cartLimitController: CartLimitReachedModalController;

    constructor(props: ICartLimitReachedModal) {
        super(props);
        this.cartLimitController = diContainer.get(serviceNames.cartLimitReachedModalController);
    }

    private parseLimitMessage = (skuLimit = 0) => {
        const { cartLimitReached = '' } = this.props
            .translations as ICartLimitReachedModalTranslations;

        cartLimitReached.replace('::skuLimit::', skuLimit.toString());
        cartLimitReached.replace('::skuMax::', (skuLimit + 1).toString());

        return cartLimitReached;
    };

    private onConfirm = () => {
        this.cartLimitController.toggleModal(false);
    };

    public render() {
        const { okLabel } = this.props.translations as ICartLimitReachedModalTranslations;
        const { shouldDisplayModal, maxSkuLimit } = this.cartLimitController;

        return (
            <ResponsiveModal isOpen={shouldDisplayModal} title="cart-limit-reached">
                <ModalMessageContainer>
                    <p>{this.parseLimitMessage(maxSkuLimit)}</p>
                </ModalMessageContainer>
                <ModalFooter>
                    <Button
                        className="elc-cart-limit-modal-button js-cart-limit-modal-button"
                        onClick={this.onConfirm}
                    >
                        {okLabel}
                    </Button>
                </ModalFooter>
            </ResponsiveModal>
        );
    }
}
